var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8289 12.1078V20.0575C19.8289 21.3696 18.8255 22.3729 17.5134 22.3729H4.31544C3.00336 22.3729 2 21.3696 2 20.0575V6.62794C2 5.31586 3.00336 4.3125 4.31544 4.3125H11.9564",
    stroke: "#B08C3D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1846 12.8791L11.5705 10.3322C11.5705 10.1778 11.6476 10.0234 11.802 9.94625C12.8054 9.02008 17.6678 4.23484 18.4396 3.38585C19.3658 2.45967 20.4463 1.30195 21.604 2.53685C22.5302 3.5402 21.6812 4.46637 20.6007 5.54691C19.6745 6.55027 15.198 11.0268 14.2718 11.953C14.1946 12.0301 14.0403 12.1073 13.8859 12.1845L11.1846 12.8791Z",
    fill: "#B08C3D",
    stroke: "#B08C3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalIcon);
export default __webpack_public_path__ + "static/media/journal-icon.3088d310355b4ba8427df6a7859b13be.svg";
export { ForwardRef as ReactComponent };